import { merge } from 'lodash';
import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Card, CardHeader, Stack, Box } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
//
import { BaseOptionChart } from '../../charts';

// ----------------------------------------------------------------------





function AppCurrentVisits(props) {
  const [chartColors, setChartColors] = useState([]);
  useEffect(() => {
    if (props.patients.gender_categories.length === 1) {
      if (props.patients.gender_categories[0] == "Male")
        setChartColors(["#ff8533"]);
      else setChartColors(["#4f9ea9"]);
    } else {
      setChartColors(["#4f9ea9", "#ff8533"]);
    }
  }, [props.patients.gender_categories]);

  const CHART_DATAFemale = [{
    data: props.patients.gender_patients
  }]
  const chartOptions_MaleFemaleBar = merge(BaseOptionChart(), {
    tooltip: {
      enabled: false,
      marker: { show: false },
      x: {
        show: true,
        // format: 'dd MMM',
        formatter: undefined,
        title: {
          formatter: (seriesName) => seriesName,
        }
      },
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: (seriesName) => `Number prescribed: `
        }
      },
    },
    grid: {
      borderColor: "transparent",
      row: {
        colors: ["transparent"], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    colors: chartColors,
    plotOptions: {
      bar:
      {
        horizontal: false,
        dataLabels: {
          position: 'top'
        },
        columnWidth: '50%',
        borderRadius: 10,
        distributed: true,
      },
      chart: {
        brush: {
          enabled: false,
          target: 'GenderDonut',
          autoScaleYaxis: false,
          id: 'GenderBar',
          group: 'Gender'
        },
        type: 'area',
        events: {
          dataPointSelection: (event, chartContext, config) => {
            console.log(chartContext, config);
          }
        },
        states: {
          normal: {
            filter: {
              type: 'none',
              value: 0,
            }
          },
          hover: {
            filter: {
              type: 'lighten',
              value: 0.15,
            }
          },
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: 'none',
              value: 0,
            }
          },
        }
      },
    },
    legend: {
      show: false
    },
    dataLabels: {
      formatter: function (val, opt) {
      const label_value = fNumber(val)
      return label_value
    },
      enabled: true,
      style: {
        colors: ['#708090']
      },
      offsetY: -20
    },
    xaxis: {
      categories: props.patients.gender_categories,
      colors: '#708090'
      // position: 'top',
    },
    yaxis: {
      show: false,
    },
    stroke: {
      show: false,
    },
  });


  return (
    <Card sx={{ boxShadow: 'none', mt: 6 }}>
      <Box sx={{ mx: 1 }} dir="ltr">
        <ReactApexChart type="bar" series={CHART_DATAFemale} options={chartOptions_MaleFemaleBar} height={300} />
      </Box>
    </Card>
  );
}



import { connect } from "react-redux";
const mapState = state => ({
  patients: state.overview.patients
});

const mapDispatch = ({
  overview: { loadData } }) => ({
    loadData: () => loadData()
  });

export default connect(mapState, mapDispatch)(AppCurrentVisits);